<span>
  <img [class.disabled]="!enable" src="assets/images/logos/IG_Glyph_Fill.png">
</span>
